var _rect, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftToRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 252,
    viewBox: "0 0 331 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.814,
    y: 109.889,
    width: 109.889,
    height: 109.889,
    rx: 54.9445,
    fill: "#00DD97"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.759,
    cy: 140.109,
    rx: 27.4722,
    ry: 24.725,
    fill: "#001B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftToRight1);
export default __webpack_public_path__ + "static/media/Left-To-Right-1.832eedd286b3b0548a45f5e45fcba085.svg";
export { ForwardRef as ReactComponent };